import { createStore } from 'effector';
import { OrganizationPrivilege, OrgMemberRole, OrgMemberRoleAndPrivileges } from '@nx-frontend/shared/types';

export const initialOrgRole = 'visitor';

export const initialOrgRoleState: OrgMemberRoleAndPrivileges = {
  role: initialOrgRole,
  privileges: [],
  reduced: false,
};

export const $orgRoleState = createStore(initialOrgRoleState);

export const $orgRole = $orgRoleState.map((role) => role.role);

export const $isOwner = $orgRoleState.map((role) => role.role === OrgMemberRole.OWNER);

export const $opCanManageCustomHTMLIntegrations = $orgRoleState.map((role) => {
  return role?.privileges?.includes(OrganizationPrivilege.CAN_MANAGE_CUSTOM_HTML_INTEGRATIONS) || false;
});

export const $opCanManageWorkspacesBranding = $orgRoleState.map((role) => {
  return role?.privileges?.includes(OrganizationPrivilege.CAN_MANAGE_WORKSPACES_BRANDING);
});

export const $opCanManageWorkspaces = $orgRoleState.map((role) => {
  return role?.privileges?.includes(OrganizationPrivilege.CAN_MANAGE_WORKSPACES);
});

export const $opCanManageBilling = $orgRoleState.map((role) => {
  return role?.privileges?.includes(OrganizationPrivilege.CAN_MANAGE_BILLING);
});

export const $opCanAccessWebnotes = $orgRoleState.map((role) => {
  return role?.privileges?.includes(OrganizationPrivilege.CAN_ACCESS_WEBNOTES);
});

export const $opCanCreatePortal = $orgRoleState.map((role) => {
  return role?.privileges?.includes(OrganizationPrivilege.CAN_CREATE_PORTAL) || false;
});

export const $opCanManageAgents = $orgRoleState.map((role) => {
  return role?.privileges?.includes(OrganizationPrivilege.CAN_MANAGE_AGENTS) || false;
});
